import {
  InErrorsState,
  inErrorsReducer,
} from '@lifen-sending/features/in-errors/store/inErrors.slice';
import { combineReducers } from '@reduxjs/toolkit';

import { IntegrationsState } from '@store/integrations/integrations.state';
import { NotificationState } from '@store/notificationWindow/notificationWindow.state';

import { desktopReducer } from './desktop/desktop.reducer';
import { DesktopState } from './desktop/desktop.state';
import { documentArchivedReducer } from './documents/incoming/archived.slice';
import { ArchivedDocumentsState } from './documents/incoming/archived.state';
import { documentInboxReducer } from './documents/incoming/inbox.slice';
import { InboxDocumentsState } from './documents/incoming/inbox.state';
import { integrationsWorklistReducer } from './documents/integrations/worklist.slice';
import { WorklistIntegrationsState } from './documents/integrations/worklist.state';
import { documentDraftReducer } from './documents/outgoing/draft.slice';
import { DraftDocumentsState } from './documents/outgoing/draft.state';
import { documentErroredReducer } from './documents/outgoing/errored.slice';
import { ErroredDocumentsState } from './documents/outgoing/errored.state';
import { documentSentReducer } from './documents/outgoing/sent.slice';
import { SentDocumentsState } from './documents/outgoing/sent.state';
import { entitiesReducer } from './entities/entities.reducer';
import { EntitiesState } from './entities/entities.state';
import { integrationsReducer } from './integrations/integrations.slice';
import { notificationReducer } from './notificationWindow/notificationWindow.reducer';
import { selectionReducer } from './selection/selection.reducer';
import { SelectionState } from './selection/selection.state';
import { uploadDocumentsReducer } from './uploadDocuments/uploadDocuments.slice';
import { UploadDocumentsState } from './uploadDocuments/uploadDocuments.state';
import { userReducer } from './user/user.reducer';
import { UserDataTokenless } from './user/user.state';

export interface State {
  desktop: DesktopState;
  documentArchived: ArchivedDocumentsState;
  documentDraft: DraftDocumentsState;
  documentErrored: ErroredDocumentsState;
  documentInbox: InboxDocumentsState;
  documentSent: SentDocumentsState;
  entitiesState: EntitiesState;
  inErrors: InErrorsState;
  integrationRequestWorklist: WorklistIntegrationsState;
  integrations: IntegrationsState;
  notification: NotificationState;
  selection: SelectionState;
  uploadDocuments: UploadDocumentsState;
  user: UserDataTokenless;
}

export const createRootReducer = () =>
  combineReducers({
    desktop: desktopReducer,
    documentArchived: documentArchivedReducer,
    documentDraft: documentDraftReducer,
    documentErrored: documentErroredReducer,
    documentInbox: documentInboxReducer,
    documentSent: documentSentReducer,
    entitiesState: entitiesReducer,
    inErrors: inErrorsReducer,
    integrations: integrationsReducer,
    integrationRequestWorklist: integrationsWorklistReducer,
    notification: notificationReducer,
    selection: selectionReducer,
    uploadDocuments: uploadDocumentsReducer,
    user: userReducer,
  });
